import { defineStore } from 'pinia'
import { preAuthorizationService } from '@/services/preAuthorizationService'
import errorService from '@/services/errorService';

export const usePreAuthorizationStore = defineStore('preAuthorization', {
  state: () => ({
    preAuthorizations: {
      meta: {}
    },
    preAuthorization: {},
    filter: {},
  }),

  actions: {
    async getPreAuthorizations() {
      try {
        const response = await preAuthorizationService.fetchPreAuthorizations(this.filter);
        this.preAuthorizations = response.data;
      } catch (error) {
        return errorService.handle(error);
      }
    },

    async getPreAuthorization(id) {
      try {
        const response = await preAuthorizationService.fetchPreAuthorization(id);
        this.preAuthorization = response.data.data;

      } catch (error) {
        return errorService.handle(error);
      }
    },

    async addPreAuthorization(params) {

      try {
        const response = await preAuthorizationService.createPreAuthorization(params);
        this.preAuthorization = response.data.data;

        return { success: true };
      }
      catch (error) {
        return errorService.handle(error);
      }
    },
    
  }
}); 